export default "__VITE_ASSET__DXAkPgLk__"